export default __webpack_public_path__ + "static/media/LaddrPayLogo.a2fad2cc.png";